import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";
import { Link } from "react-router-dom";

const AllocatedPayments = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [voletData, setVoletData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [loading, setLoading] = useState(true);
    const [carPrices, setCarPrices] = useState({});

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        fetchVoletData();
        fetchClients();
        fetchCarPrices();
    }, []);

    useEffect(() => {
        if (selectedClient && voletData.length > 0) {
            const filtered = voletData.filter(item => {
                const itemClientId = Number(item.client_id);
                const selectedClientId = Number(selectedClient);
                return itemClientId === selectedClientId && item.stock_id && item.stock_id !== '-';
            });
            setFilteredData(filtered);
            console.log("Filtered data:", filtered);
        } else {
            setFilteredData([]);
        }
    }, [selectedClient, voletData]);

    const fetchVoletData = async () => {
        try {
            const response = await fetch("https://api.mitradingjp.com/fetchallocated.php");
            const data = await response.json();
            console.log("Fetched allocated data:", data);
            
            const formattedData = data.map(item => ({
                ...item,
                client_id: Number(item.client_id),
                received_amount: parseFloat(item.received_amount) || 0,
                allocated_amount: parseFloat(item.allocated_amount) || 0,
                conversion_rate: parseFloat(item.conversion_rate) || 1,
                vin: item.vin || 'N/A' // Ensure vin is included, default to 'N/A' if missing
            }));
            setVoletData(formattedData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching allocated data:", error);
            setLoading(false);
        }
    };

    const fetchClients = async () => {
        try {
            const response = await fetch("https://api.mitradingjp.com/fetchallocatedclients.php");
            const data = await response.json();
            console.log("Fetched clients:", data);
            setClients(data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const fetchCarPrices = async () => {
        try {
            const response = await fetch("https://api.mitradingjp.com/fetchcarprices.php");
            const data = await response.json();
            const prices = {};
            data.forEach(car => {
                prices[car.stock_id] = parseFloat(car.sold_price) || 0;
            });
            setCarPrices(prices);
        } catch (error) {
            console.error("Error fetching car prices:", error);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const formatCurrency = (amount) => {
        return `$${amount.toFixed(2)}`;
    };

    const formatPaymentMethod = (method) => {
        if (!method) return 'N/A';
        const methods = {
            'bank_transfer': 'Bank Transfer',
            'credit_card': 'Credit Card',
            'paypal': 'PayPal',
            'cash': 'Cash'
        };
        return methods[method] || method;
    };

    const formatConversionRate = (rate, currency) => {
        return `${rate.toFixed(4)} (${currency})`;
    };

    const remainingBalances = {};

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3>View Allocated Payments</h3>
                        <Link to="/create-allocate" className="btn btn-primary">
                            Create New Allocation
                        </Link>
                    </div>

                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="clientFilter" className="form-label">Filter by Client</label>
                                    <select
                                        id="clientFilter"
                                        className="form-select"
                                        value={selectedClient}
                                        onChange={(e) => setSelectedClient(e.target.value)}
                                    >
                                        <option value="">Select a client</option>
                                        {clients.map(client => (
                                            <option key={client.id} value={client.id}>
                                                {client.name} ({client.stock_ids.length > 0 ? client.stock_ids.join(', ') : 'No Stock IDs'})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>Date</th>
                                        <th>Client Name</th>
                                        <th>Stock ID</th>
                                        <th>Chassis#</th>
                                        <th>Payment Method</th>
                                        <th>Price</th>
                                        <th>Allocated Amount</th>
                                        <th>Remaining Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item) => {
                                            const price = carPrices[item.stock_id] || 0;
                                            let remainingBalance;

                                            if (!(item.stock_id in remainingBalances)) {
                                                remainingBalance = price - item.allocated_amount;
                                            } else {
                                                remainingBalance = remainingBalances[item.stock_id] - item.allocated_amount;
                                            }
                                            remainingBalances[item.stock_id] = remainingBalance;

                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{formatDate(item.date)}</td>
                                                    <td>{item.client_name}</td>
                                                    <td>{item.stock_id}</td>
                                                    <td>{item.vin}</td>
                                                    <td>{formatPaymentMethod(item.payment_method)}</td>
                                                    <td>{formatCurrency(price)}</td>                                                    
                                                    <td>{formatCurrency(item.allocated_amount)}</td>
                                                    <td className={remainingBalance < 0 ? 'text-danger' : ''}>
                                                        {formatCurrency(remainingBalance)}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                {selectedClient ? "No allocated payment records found for selected client" : "Please select a client to view payments"}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AllocatedPayments;